import { utils } from '@hh/global.js'

const { isMobile } = utils

class HHIngredient extends HTMLElement {
  constructor() {
    super()

    this.onClickCard = this.onClickCard.bind(this)
    this._openCardModal = this._openCardModal.bind(this)
    this._closeCardModal = this._closeCardModal.bind(this)
  }

  connectedCallback() {
    this.$title = this.querySelector('.ingredient-title')
    this.$image = this.querySelector('.ingredient-image-container')
    this.$descriptionElem = this.querySelector('.js-ingredient-desc')
    this.$description = this.$descriptionElem.querySelector('p')
    this.$learnMore = this.querySelector('.js-ingredient-card-learn')
    this.$ingredientCardModal = document.querySelector('#ingredient-card-modal')
    this.$closeButtons = this.$ingredientCardModal?.querySelectorAll(
      '.js-ingredient-card-modal-close'
    )
    this.$ingredientCardModalTitle = this.$ingredientCardModal?.querySelector(
      '.ingredient-card-modal__title'
    )
    this.$ingredientCardModalImage = this.$ingredientCardModal?.querySelector(
      '.ingredient-card-modal__image'
    )
    this.$ingredientCardModalDesc = this.$ingredientCardModal?.querySelector(
      '.ingredient-card-modal__desc'
    )

    this._attachListeners()

    setTimeout(() => {
      this.setTitleHeight()
    }, 2000)
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    this.addEventListener('click', this.onClickCard)

    this.addEventListener(
      'mouseenter',
      () => {
        if (!isMobile()) {
          this.$descriptionElem.classList.add('is-visible')
        }
      },
      false
    )

    this.addEventListener(
      'mouseleave',
      () => {
        if (!isMobile()) {
          this.$descriptionElem.classList.remove('is-visible')
        }
      },
      false
    )

    this.$learnMore.addEventListener('click', this._openCardModal)

    this.$closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this._closeCardModal())
    })

    window.addEventListener('resize', () => this.setTitleHeight())
  }

  _removeListeners() {
    this.removeEventListener('click', this.onClickCard)
    this.$learnMore.removeEventListener('click', this._openCardModal)
    this.$closeButtons.forEach((btn) => {
      btn.removeEventListener('click', () => this._closeCardModal())
    })
  }

  _openCardModal() {
    this.$ingredientCardModalTitle.innerHTML = this.$title.innerHTML
    this.$ingredientCardModalImage.innerHTML = this.$image.innerHTML
    this.$ingredientCardModalDesc.innerHTML = this.$description.innerHTML

    this.$ingredientCardModal.classList.add('active')
    this.$ingredientCardModal.setAttribute('open', true)

    document.documentElement.classList.add('scroll-lock')
    this.$ingredientCardModal.focus()
  }

  _closeCardModal() {
    this.$ingredientCardModal.classList.remove('active')
    this.$ingredientCardModal.removeAttribute('open')

    this.$ingredientCardModalTitle.innerHTML = ''
    this.$ingredientCardModalImage.innerHTML = ''
    this.$ingredientCardModalDesc.innerHTML = ''

    document.documentElement.classList.remove('scroll-lock')
  }

  onClickCard() {
    if (!isMobile()) {
      this.$descriptionElem.classList.toggle('is-visible')
      document
        .querySelectorAll(
          `hh-ingredient:not([data-id="${this.dataset.id}"]) .js-ingredient-desc.is-visible`
        )
        ?.forEach((el) => {
          el.classList.remove('is-visible')
        })
    }
  }

  setTitleHeight() {
    return;
    const titleHeight = Math.max(
      ...Array.from(
        this.$title
          .closest('.ingredients')
          .querySelectorAll('.ingredient-title')
      ).map((el) => {
        const { height } = el.getBoundingClientRect()
        return height
      })
    )

    this.$title.style.minHeight = `${titleHeight}px`
  }
}

customElements.define('hh-ingredient', HHIngredient)
